import { useQuery } from '@tanstack/react-query'
import React, { FunctionComponent, useEffect, useState } from 'react'

import FormSelect from '../../../base/components/Form/FormSelect'
import InputSkeleton from '../../../base/components/skeleton/InputSkeleton'
import { SinTipoMonedaProps } from '../../../interfaces/sin.interface'
import { apiSinMonedaListado } from '../api/apiSinMonedaListado'

interface OwnProps {
  inputRequired?: boolean
  inputDisabled?: boolean
  isError?: boolean
  helperText?: string
  value?: SinTipoMonedaProps | null
  onInputChange: (value?: SinTipoMonedaProps | null) => void
}

type Props = OwnProps

/**
 * Componente para seleccionar un proveedor
 * @param props
 * @constructor
 */
const SinMonedaField: FunctionComponent<Props> = (props) => {
  const { inputRequired, inputDisabled, isError, helperText, value, onInputChange } =
    props

  const [sinTipoMoneda, setSinTipoMoneda] = useState<SinTipoMonedaProps | null>(null)

  const { data: sinTipoMonedaListado, isLoading: sinTipoMonedaLoading } = useQuery({
    queryKey: ['sin Tipo Moneda'],
    queryFn: async () => apiSinMonedaListado(),
    refetchInterval: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  })

  useEffect(() => {
    if (value) {
      setSinTipoMoneda(value)
    }
  }, [value])

  if (sinTipoMonedaLoading) {
    return (
      <>
        <InputSkeleton />
      </>
    )
  }

  return (
    <>
      <FormSelect<SinTipoMonedaProps>
        inputLabel={`Homologación Moneda ${inputRequired ? '*' : ''}`}
        options={sinTipoMonedaListado || []}
        value={sinTipoMoneda}
        onChange={(val) => {
          setSinTipoMoneda(val)
          onInputChange(val)
        }}
        required={!!inputRequired}
        getOptionValue={(option) => option.codigoClasificador?.toString() || ''}
        getOptionLabel={(option) =>
          `${option.codigoClasificador} - ${option.descripcion}`
        }
        isClearable={true}
        isDisabled={!!inputDisabled}
        error={!!isError}
        formHelperText={helperText}
      />
    </>
  )
}

export default SinMonedaField
